<template>
  <div id="app">
    <!-- <div v-wechat-title="$route.params.title"></div> -->
    <div id="nav" v-if="!$store.state.mediaPhone">
      <header-bar></header-bar>
    </div>
    <router-view/>
  </div>
</template>

<script>
 import HeaderBar from '@/components/HeaderBar.vue';
 import BottomBar from '@/components/BottomBar.vue';
 export default{
   components: {
     HeaderBar,
     BottomBar
   },
   created(){
     window.checkTime()
   }
 }
</script>
<style>
 @import './assets/styles/variables.css';
 @import './assets/styles/global.css';
 #app {
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   color: #2c3e50;
 }
 #nav {
   padding: 30px;
   position: fixed;
   z-index: 9999;
 }

 #nav a {
   font-weight: bold;
   color: #2c3e50;
 }

 #nav a.router-link-exact-active {
   color: #42b983;
 }
</style>
